import React, {Component} from 'react';
import './ProgressBar.css';

export default class ProgressBar extends Component {
	render() {
		let progressPercent = (this.props.progress / this.props.total) * 100;
		progressPercent = Math.max(progressPercent, 10);
		const firstName = (progressPercent >= 50 && this.props.name) ? (' ' +(this.props.name || '')) : '';
		const lastName = (progressPercent < 50 && this.props.name) ? (' ' +(this.props.name || '')) : '';
		return (<div className={"g-progress-bar " + (this.props.className || '')}>
				<div style={{width: progressPercent + '%'}} className={'progress'}>{this.props.progress}{firstName}</div>
				<div style={{width: (100 - progressPercent) + '%'}} className={'total'}>{this.props.total}{lastName}</div>
			</div>
		)
	}
}